import { render, staticRenderFns } from "./ArrayInspector.vue?vue&type=template&id=a9be3834&lang=pug&"
import script from "./ArrayInspector.vue?vue&type=script&lang=js&"
export * from "./ArrayInspector.vue?vue&type=script&lang=js&"
import style0 from "./ArrayInspector.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/node/authoring/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a9be3834')) {
      api.createRecord('a9be3834', component.options)
    } else {
      api.reload('a9be3834', component.options)
    }
    module.hot.accept("./ArrayInspector.vue?vue&type=template&id=a9be3834&lang=pug&", function () {
      api.rerender('a9be3834', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/inspector/ArrayInspector.vue"
export default component.exports